import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sessionState } from "../redux/selectors/sessionSelector";
import { authUser } from "../redux/selectors/authSelectors";
import { useNavigate } from "react-router-dom";
import { initGetSessions } from "../redux/actions";
import { initGetResults } from "../redux/actions/scenariosActions";

function sessionStatus(session) {
  const raw = session?.status;
  if (typeof raw === "string" && raw.trim()) {
    return raw.trim().toLowerCase();
  }
  return "pending";
}

function sessionMatchKey(session) {
  const topic = (session?.topic || "").trim().toLowerCase();
  const mentor = (session?.mentor || "").trim().toLowerCase();
  return `${topic}::${mentor}`;
}

function filterSessions(sessions, active) {
  const completedKeys = new Set(
    sessions
      .filter((session) => sessionStatus(session) === "completed")
      .map(sessionMatchKey),
  );

  return sessions.filter((session) => {
    const status = sessionStatus(session);
    if (active) {
      if (status !== "pending") return false;
      // Drop stale pending bookings when the same topic already has a completed session.
      return !completedKeys.has(sessionMatchKey(session));
    }
    return status === "completed";
  });
}

const useSessionsHistory = (active) => {
  const naviGate = useNavigate();
  const dispatch = useDispatch();
  const { sessions } = useSelector(sessionState)
  const storageUser = useSelector((state) => authUser(state));
  const { role } = storageUser || {};
  const { results, isLoading } = useSelector(state => state.scenariosReducer);
  const mentors = useSelector((state) => state.mentorReducer?.mentor?.results)
  const [mentorRates, setMentorRates] = useState(null)
    const hasHitTheApi = useRef(false)
  
  useEffect(() => {
    if (!hasHitTheApi.current) {
      dispatch(initGetResults())
    dispatch(initGetSessions());
    hasHitTheApi.current = true
    }
  }, []);
  const findMentor = (mentorId) => {
    return mentors.find((el) => el.id === mentorId).first_name
  }
  const handleRatingChange = (mentorId, newRating) => {
    let newobj = {}
    if (mentorRates === null) {
      for (let i = 0; i < sessions.length; i++) {
        if (sessions[i].id === mentorId) {
          newobj[sessions[i].id] = [newRating]
        }
        else {
          newobj[sessions[i].id] = []
        }
      }
      setMentorRates(newobj)
    } else {
      setMentorRates({ ...mentorRates, [mentorId]: [newRating] })
    }
  }
  return {
    role,
    isTestCompleted:isLoading?true:results?.length,
    sessions: filterSessions(sessions, active),
    mentorRates,
    handleRatingChange,
    naviGate,
    findMentor
  }
}

export default useSessionsHistory;